export function swapArrayElements(array, index1, index2) {
    array[index2] = array.splice(index1, 1, array[index2])[0];
}
export function abs(num) {
    if (num < 0)
        return -num;
    return num;
}
